import React, { Component } from 'react'
import ComingSoon from '../components/coming-soon/ComingSoon'
import ConfirmRegisterForm from '../components/register/ConfirmRegister'
import Delivery from '../components/home/Delivery'
import GenericSuccessModal from '../components/success-modal/GenericSuccessModal'
import LoginOrJoin from '../components/login/LoginOrJoin'
import ModalPopup from '../components/common/ModalPopup'
import NoDeliveriesToday from '../components/home/NoDeliveriesToday'
import OrderStatusSidebar from '../components/common/OrderStatusSidebar'
import PiggyBank from '../components/community/PiggyBank'
import ReferralSuccessNotification from '../components/community/ReferralSuccessNotification'
import SlackBotSuccessModal from '../components/slack/SlackBotSuccessModal'
import URLSearchParams from 'url-search-params'
import uniqBy from 'lodash/uniqBy'
import { Article, SpinnerCard } from '../components/common/Layout'
import { DailyLink } from '../components/home/DailyLink'
import { Redirect } from 'react-router-dom'
import { SimpleSpinner } from '../components/common/SimpleSpinner'
import { YourLocation } from '../components/home/YourLocation'
import { changeSelectedDay } from '../redux/modules/home'
import { confirmPasswordStart } from '../redux/modules/user'
import { connect } from 'react-redux'
import { format } from 'date-fns'
import { loadAvailableCreditsStart } from '../redux/modules/creditHistory'
import { loadLocationStart } from '../redux/modules/location'
import { loadOrderStart } from '../redux/modules/orderDetail'
import { loadProfileStart } from '../redux/modules/profile'
import { notificationAck } from '../redux/modules/notification'
import { pushAnalyticsEvent } from '../util/gtmUtils'
import { reduxForm } from 'redux-form'
import { selectLocationRoute, noLocationRoute } from '../routes/routes'
import UpdateUserLocationPanel from '../components/location-search/UpdateUserLocationPanel'
import {
  checkPiggybankStatusStart,
  checkDailyLinkStatusStart,
} from '../redux/modules/featureToggles'
import {
  clearFriendsAtDateTime,
  getFriendRequestCount,
  getFriendsOrdersStart,
  loadFriendsStart,
  loadFriendsAtDateTimeStart,
} from '../redux/modules/friends'
import {
  selectCurrentLocationWithAddress,
  selectUserLocationId,
  isSelectedDeliveryDateActive,
} from '../redux/modules/selectors'
import {
  loadDeliveryScheduleStart,
  loadDeliveryScheduleFailure,
  selectDelivery,
} from '../redux/modules/delivery'
import SubscriptionPromotional from '../components/home/SubscriptionPromotional'

export const ConfirmRegisterContainer = reduxForm({ form: 'confirmpassword' })(
  ConfirmRegisterForm,
)

const LoadDayError = () => (
  <div className="center-xs">
    <h5 className="error center-xs">
      <i className="icon-warning" /> Oops! Something went wrong.
    </h5>
    <p>
      Try refreshing the page or switching between days. If this problem
      persists, please <a href={`/contact`}>contact support</a>
    </p>
  </div>
)

const getRedirect = location => {
  if (location) {
    if (location.locationType === 'GroupOrder') {
      const query = new URLSearchParams()
      const { street, city, state, zip } = location.address
      query.set('address', `${street} ${city}, ${state} ${zip}`)
      return <Redirect to={`${selectLocationRoute.path}?${query.toString()}`} />
    } else if (location.activationDate === null) {
      return <Redirect to={noLocationRoute.path} />
    }
  }
  return null
}

class Home extends Component {
  componentDidMount() {
    const {
      match: {
        params: { locationId },
      },
    } = this.props
    const {
      checkDailyLinkStatusStart,
      isAuthenticated,
      loadLocationStart,
    } = this.props
    loadLocationStart(locationId)
    this.fetchDeliveries(locationId)
    checkDailyLinkStatusStart(locationId)
    if (isAuthenticated) {
      this.fetchPageData(locationId)
    }
    pushAnalyticsEvent('Ordering', 'View Deliveries', undefined, locationId)
  }

  componentDidUpdate(prevProps) {
    const { isAuthenticated, loadLocationStart, selectedDate } = this.props
    let {
      match: {
        params: { locationId = 0 },
      },
    } = this.props
    locationId = Number(locationId)
    if (Number(prevProps.match.params.locationId) !== locationId) {
      loadLocationStart(locationId)
      this.fetchDeliveries(locationId)
      this.fetchPageData(locationId, true)
    }
    if (prevProps.isAuthenticated === false && isAuthenticated === true) {
      this.fetchPageData(locationId)
    }
    if (prevProps.selectedDate !== selectedDate) {
      this.fetchFriendOrders(selectedDate)
    }
  }

  fetchDeliveries = locationId => {
    const { selectedDate, loadDeliveryScheduleStart } = this.props
    loadDeliveryScheduleStart(locationId, selectedDate)
  }

  fetchFriendOrders = (date, forceUpdateCache) => {
    const { isAuthenticated, locationId, getFriendsOrdersStart } = this.props
    if (isAuthenticated) {
      getFriendsOrdersStart(format(date, 'YYYY-MM-DD'), locationId, {
        forceUpdate: forceUpdateCache,
      })
    }
  }

  fetchPageData = (currentLocationId, forceUpdateCache) => {
    const {
      checkPiggybankStatusStart,
      getFriendRequestCount,
      getFriendsOrdersStart,
      isAuthenticated,
      loadAvailableCreditsStart,
      loadFriendsStart,
      loadOrderStart,
      selectedDate,
    } = this.props
    const locationId =
      currentLocationId || Number(this.props.match.params.locationId)
    if (isAuthenticated) {
      checkPiggybankStatusStart(locationId)
      loadOrderStart(selectedDate, locationId)
      loadAvailableCreditsStart()
      getFriendRequestCount('INCOMING', { forceUpdate: forceUpdateCache })
      getFriendsOrdersStart(
        format(this.props.selectedDate, 'YYYY-MM-DD'),
        locationId,
        { forceUpdate: forceUpdateCache },
      )
      loadFriendsStart({ forceUpdate: forceUpdateCache })
    }
  }

  passwordVisibility() {
    let currentType = document.getElementById('loginPassword')
    currentType.type === 'password'
      ? (currentType.type = 'text')
      : (currentType.type = 'password')
  }

  render() {
    const {
      activationDate,
      changeSelectedDay,
      clearFriendsAtDateTime,
      confirmPasswordError,
      confirmPasswordStart,
      dailyLinkStatus,
      deliveries,
      deliveryError,
      friends,
      friendsAtOrderDelivered,
      friendsOrderCount,
      history,
      isAuthenticated,
      isCheckingStatus,
      isLoadingDeliveries,
      isLoadingFriendsOrders,
      isLocationLoading,
      isOrdersLoading,
      isSelectedDayActive,
      isWebpSupported,
      loadFriendsAtDateTimeStart,
      loadingNewDay,
      location,
      orders,
      piggybankStatus,
      profile,
      selectDelivery,
      selectedDate,
      submitting,
      notificationAck,
      message,
      error,
      hasChangedLocation,
      isCurrentUserLoading,
      userLocationId,
    } = this.props
    let {
      friendHasOrdered,
      match: {
        params: { locationId },
      },
    } = this.props
    locationId = Number(locationId)

    const newUser = profile && profile.status !== 'CONFIRMED'

    const redirect = getRedirect(location)

    const changeLocationModal =
      !isCurrentUserLoading &&
      isAuthenticated &&
      !hasChangedLocation &&
      locationId.toString() !== userLocationId.toString() ? (
        <ModalPopup showCancel={false}>
          <UpdateUserLocationPanel locationId={locationId} />
        </ModalPopup>
      ) : null

    return (
      <Article classnames="home">
        <SlackBotSuccessModal />
        <ReferralSuccessNotification />
        <GenericSuccessModal
          isError={error}
          message={message}
          notificationAck={notificationAck}
        />
        <>
          {newUser && (
            <ModalPopup showCancel={false}>
              <ConfirmRegisterContainer
                confirmPasswordError={confirmPasswordError}
                onSubmit={confirmPasswordStart}
                submitting={submitting}
              />
            </ModalPopup>
          )}

          {redirect}
          {changeLocationModal}
          {!deliveryError ? (
            isSelectedDayActive ? (
              <>
                {!isAuthenticated && (
                  <ModalPopup showCancel={false}>
                    <LoginOrJoin
                      joinTitle="Register to Order"
                      locationId={locationId}
                      loginMessage="Login to see deliveries and get lunch delivered to your office."
                      loginTitle="Login to Order"
                      signupMessage="Sign up to see available restaurants and get lunch delivered to your office."
                    />
                  </ModalPopup>
                )}
                <SubscriptionPromotional />
                <YourLocation
                  address={location.address}
                  name={location.deliveryLocationName}
                  selectedDate={selectedDate}
                  showLink={true}
                />
                {dailyLinkStatus && (
                  <DailyLink
                    history={history}
                    isAuthenticated={isAuthenticated}
                  />
                )}
                {orders && orders.length > 0 ? (
                  <SpinnerCard
                    spinnerActive={
                      isLoadingDeliveries || isLoadingFriendsOrders
                    }
                  >
                    <div className="statusContainer">
                      <OrderStatusSidebar locationId={locationId} />
                    </div>
                  </SpinnerCard>
                ) : null}
                {orders && orders.length >= 0 && piggybankStatus && (
                  <div style={{ marginBottom: '20px' }}>
                    <SpinnerCard
                      spinnerActive={
                        isOrdersLoading ||
                        isLoadingDeliveries ||
                        isLoadingFriendsOrders ||
                        isCheckingStatus
                      }
                    >
                      <div className="statusContainer">
                        <PiggyBank
                          style={{ marginBottom: '16px' }}
                          {...{
                            friends,
                            friendsOrderCount:
                              friendsOrderCount &&
                              uniqBy(
                                friendsOrderCount.reduce(
                                  (ordered, i) => ordered.concat(i.friend),
                                  [],
                                ),
                                'userId',
                              ),
                            friendsAtOrderDelivered,
                            orders,
                            locationId,
                            activeOrders:
                              orders &&
                              orders.filter(
                                order => order.orderState !== 'CANCELED',
                              ),
                            loadFriendsAtDateTimeStart,
                            selectedDate,
                            profile,
                            isWebpSupported,
                          }}
                        />
                      </div>
                    </SpinnerCard>
                  </div>
                )}
                {!loadingNewDay ? (
                  <>
                    {/* If location had deliveries show delivery cards or show no delivery screen */}
                    {deliveries && deliveries.length ? (
                      <Delivery
                        deliveries={deliveries}
                        friendHasOrdered={friendHasOrdered}
                        isSelectedDayActive={isSelectedDayActive}
                        isWebpSupported={isWebpSupported}
                        locationId={locationId}
                        selectDelivery={selectDelivery}
                        selectedDate={selectedDate}
                      />
                    ) : (
                      <NoDeliveriesToday selectedDate={selectedDate} />
                    )}
                  </>
                ) : null}
              </>
            ) : !isLocationLoading ? (
              <ComingSoon
                activationDate={activationDate}
                isAuthenticated={isAuthenticated}
                locationId={locationId}
                onChangeDay={date => {
                  changeSelectedDay(date, locationId)
                  piggybankStatus &&
                    friendsAtOrderDelivered &&
                    clearFriendsAtDateTime()
                }}
              />
            ) : (
              <SimpleSpinner />
            )
          ) : (
            <LoadDayError />
          )}
        </>
      </Article>
    )
  }
}

const mapStateToProps = state => {
  const { deliveries, isLoadingDeliveries } = state.delivery
  const deliveryError = state.delivery.error
  const { selectedDate, loadingNewDay, loadDeliveriesForLocation } = state.home
  const {
    isAuthenticated,
    isCurrentUserLoading,
    hasChangedLocation,
    currentUser,
    submitting,
    confirmPasswordError,
  } = state.user
  const {
    isLoadingFriendsOrders,
    friendsOrderCount,
    friends,
    friendsAtOrderDelivered,
    friendHasOrdered,
    isLoadingFriendsAtDatetime,
  } = state.friends
  const { isLocationLoading } = state.location
  const location = selectCurrentLocationWithAddress(state)
  const { location: { activationDate } = {} } = state.location
  const userLocationId = selectUserLocationId(state)
  const isSelectedDayActive = isSelectedDeliveryDateActive(state)
  const { profile } = state.profile
  const { orders, loading } = state.orderDetail
  const {
    dailyLinkStatus,
    isCheckingStatus,
    piggybankStatus,
  } = state.featureToggles
  const { isWebpSupported } = state.browser
  const { message, error } = state.notification
  return {
    activationDate,
    confirmPasswordError,
    currentUser,
    dailyLinkStatus,
    deliveries,
    deliveryError,
    error,
    friendHasOrdered,
    friends,
    friendsAtOrderDelivered,
    friendsOrderCount,
    hasChangedLocation,
    isAuthenticated,
    isCheckingStatus,
    isCurrentUserLoading,
    isLoadingDeliveries,
    isLoadingFriendsAtDatetime,
    isLoadingFriendsOrders,
    isLocationLoading,
    isOrdersLoading: loading,
    isSelectedDayActive,
    isWebpSupported,
    loadDeliveriesForLocation,
    loadingNewDay,
    location,
    message,
    orders,
    piggybankStatus,
    profile,
    selectedDate,
    submitting,
    userLocationId,
  }
}

const mapDispatchToProps = {
  changeSelectedDay,
  checkDailyLinkStatusStart,
  checkPiggybankStatusStart,
  clearFriendsAtDateTime,
  confirmPasswordStart,
  getFriendRequestCount,
  getFriendsOrdersStart,
  loadAvailableCreditsStart,
  loadDeliveryScheduleFailure,
  loadDeliveryScheduleStart,
  loadFriendsAtDateTimeStart,
  loadFriendsStart,
  loadLocationStart,
  loadOrderStart,
  loadProfileStart,
  selectDelivery,
  notificationAck,
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)
